export const BASE_URL = "https://tqi.qte.nu/webserv";